import {
  addNewAlert,
  fetchAlert,
  receivedAlertUpdatedStatus,
} from '@rsos/reduxDataStore/src/features/alerts/incidentsSlice';

export const addAlertToQueue = message => dispatch => {
  dispatch(addNewAlert(message));
};

export const getAlertDetails =
  (currentApplication, currentOrgName, alertID) => dispatch => {
    dispatch(fetchAlert({ currentApplication, currentOrgName, alertID }));
  };

export const getLogMessageUpdatedStatus =
  (message, currentApplication) => dispatch => {
    // current_application is used to determine
    // if the alert message is being displayed in RSP or CSP
    message.current_application = currentApplication;
    dispatch(receivedAlertUpdatedStatus(message));
  };
